module.exports = __webpack_public_path__ + "static/resaleReport-coverDivider-thumbanil-v2-e6435e4829d16e3011760d8f21c26dae.jpg";